<template>
  <el-checkbox
    v-model="Data"
    @change="OnChange"
    :disabled="disabled || config.Disabled"
    >{{ Text }}</el-checkbox
  >
</template>
<script>
import base from "matrix.node.ui/field.js";
export default {
  mixins: [base.edit(Boolean)],
  computed: {
    Text() {
      if (this.config.NoText) return "";
      return this.Options.find((t) => {
        return t.Id === true;
      }).Title;
    },
    Options() {
      return (
        this.config.Options || [
          { Id: true, Title: "是" },
          { Id: false, Title: "否" },
        ]
      );
    },
  },
};
</script>